import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer,
} from "recharts";

// #region Sample data
const data = [
  {
    name: "03.10.2025",
    калории: 4000,
  },
  {
    name: "04.10.2025",
    калории: 1000,
  },
  {
    name: "05.10.2025",
    калории: -200,
  },
  {
    name: "06.10.2025",
    калории: 2780,
  },
  {
    name: "07.10.2025",
    калории: 1890,
  },
  {
    name: "08.10.2025",
    калории: 2390,
  },
  {
    name: "09.10.2025",
    калории: 3490,
  },
];

// #endregion
const PositiveAndNegativeBarChart = () => {
  return (
    <div
      style={{
        width: "90%",
        height: "50vh",
        minHeight: "300px",
        maxHeight: "350px",
        backgroundColor: "var(--bcg)",
        marginRight: "10px",
        marginBottom: "10px",
        marginTop: "5px",
        marginLeft: "10px",
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          style={{
            width: "100%",
            maxWidth: "500px",
            height: "50vh",
            minHeight: "300px",
            maxHeight: "250px",
            // aspectRatio: 1.618,
          }}
          data={data}
          margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis width={100} />
          <Tooltip />
          <Legend />
          <ReferenceLine y={0} stroke="#000" />

          <Bar dataKey="калории" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PositiveAndNegativeBarChart;
